import { useStateContext } from '../../context.tsx';
import { Destination } from '../Itinerary/Travel.tsx';
import { For, Show } from 'solid-js';
import './traveldescription.scss';
import { dateToString } from '../../Utility/utility.tsx';

type Itinerary = {
    name: string;
    dest: Destination;
    start: Date;
    end: Date;
}

export function TravelDescription() {
    let state = useStateContext();
    return (
        <Show when={(state.selectedEntity() as any).trips}>
        <div class="travel-card">
            <div class="travel-head">
            <h2 class="travel-region">{(state.selectedEntity() as any).trips[0].dest.region}</h2>
                <For each={(state.selectedEntity() as any).trips}>
                    {(trip: Itinerary) => {
                        return (
                                <div class="trip-dates">{dateToString(trip.start)} - {dateToString(trip.end) == dateToString(new Date()) ? "Present" : dateToString(trip.end)}</div>
                        );
                    }}
                </For>
            </div>
                <img class="travel-img" src={(state.selectedEntity() as any).trips[0].dest.destImg} alt="Trip Pictures"></img>
                <div class="trips">
                    <For each={(state.selectedEntity() as any).trips}>
                        {(trip: Itinerary) => {
                            return (
                                <div class="trip">
                                    <div class="trip-name">{trip.name}</div>
                                    <div class="trip-length">{trip.dest.length} day{trip.dest.length > 1 ? "s": ""}</div>
                                    <div class="trip-highlights">
                                        <For each={trip.dest.highlights}>
                                            {(highlight: string) => {
                                                return (
                                                    <>
                                                        <span class="degree-hightlight">◉ {highlight}</span>
                                                        <br></br>
                                                    </>
                                                )
                                            }}
                                        </For>
                                    </div>
                                    <p></p>
                                </div>
                            )
                        }}
                    </For>
                </div>
            </div>
        </Show>
    );
}
